
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyDMFBjBtXJtFXnAeRI9Z6vg-BhMgK19tN0",
  authDomain: "eyecare-optical-b82d4.firebaseapp.com",
  projectId: "eyecare-optical-b82d4",
  storageBucket: "eyecare-optical-b82d4.firebasestorage.app",
  messagingSenderId: "1018382449029",
  appId: "1:1018382449029:web:0046be61b4be0ed8f56cec"
};
  

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export